export var Position;
(function (Position) {
    Position["Student"] = "student";
    Position["Lecturer"] = "lecturer";
    Position["Admin"] = "admin";
    Position["Assistant"] = "assistant";
})(Position || (Position = {}));
